module.exports = __webpack_public_path__ + "media/images/main-bg3-a448b3381f9e487574f9437135278a2d.png";